module.exports = __webpack_public_path__ + "static/img/美的微霸系列微蒸烤炸炖五合一 GR6.18beb9dc.png";